export type BiometricAuthenticationResult =
  | { success: true }
  | { error?: string; success: false };

export type BiometricUnlockType = "face" | "fingerprint" | null;

// Web builds intentionally do not expose native biometric APIs. The native
// implementation is selected through biometricUnlock.native.ts on iOS/Android.
export const isBiometricUnlockAvailable = async (): Promise<boolean> => false;

export const getBiometricUnlockType = async (): Promise<BiometricUnlockType> =>
  null;

export const getEnrolledBiometricUnlockTypes = async (): Promise<
  BiometricUnlockType[]
> => [];

export const getBiometricUnlockEnabled = async (): Promise<boolean> => false;

export const getBiometricUnlockUserId = async (): Promise<string | null> =>
  null;

export const getBiometricUnlockPromptDeclined = async (): Promise<boolean> =>
  false;

export const setBiometricUnlockPromptDeclined = async (): Promise<void> => {};

export const enableBiometricUnlock = async (
  _userId: string
): Promise<void> => {};

export const disableBiometricUnlock = async (): Promise<void> => {};

export const signInWithBiometrics =
  async (): Promise<BiometricAuthenticationResult> => ({ success: false });

export const clearPersistedNativeSession = async (): Promise<void> => {};

export const reconcileBiometricUser = async (
  _userId: string
): Promise<void> => {};
export const prepareNativeBiometricSession = async (
  _enabled = true,
  _lockEnrolledSession = true
): Promise<void> => {};
export const persistNativePrimarySession = async (): Promise<void> => {};
